import styled from 'styled-components';

export const ImgContainer = styled.div`
  width: calc(50% - 2px);
  height: 230px;
  margin: 1px;

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  &:nth-child(1n + 3) {
    width: calc(33.33% - 2px);
    height: 140px;
  }

  &:nth-child(5) {
    position: relative;

    &:after {
      position: absolute;
      content: 'See all photos';
      color: white;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

export const Img = styled.img`
  width: 100%;
  min-height: 100%;
  object-fit: cover;

  &:hover {
    cursor: pointer;
  }
`;
